import { render, staticRenderFns } from "./ChargebackAmountsWaterfall.vue?vue&type=template&id=367f1c30&scoped=true&"
import script from "./ChargebackAmountsWaterfall.vue?vue&type=script&lang=js&"
export * from "./ChargebackAmountsWaterfall.vue?vue&type=script&lang=js&"
import style0 from "./ChargebackAmountsWaterfall.vue?vue&type=style&index=0&id=367f1c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367f1c30",
  null
  
)

export default component.exports